document.addEventListener('DOMContentLoaded', function () {
    const media = [
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/1.jpg?v=1732562342' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/2.jpg?v=1732562342' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/3.jpg?v=1732562343' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/4.jpg?v=1732563387' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/5.jpg?v=1732563387' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/6.jpg?v=1732563387' },      
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/7.jpg?v=1732563387' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/8.jpg?v=1732563387' },      
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/9.jpg?v=1732563387' },      
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/10_cdbe2405-a670-4ca9-b727-d4980d62df70.jpg?v=1732563388' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/11_e914ca6f-88f0-49e5-af8b-8105e4b5162e.jpg?v=1732563388' },
        { type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/12_fa699a91-c748-4f02-8797-25de0514333e.jpg?v=1732563388' },
        { type: 'video', src: 'https://cdn.shopify.com/videos/c/o/v/3bd69dfc84f547e8ae09911f0910a820.mp4' },
        { type: 'video', src: 'https://cdn.shopify.com/videos/c/o/v/25579d93b0af493c91833519b286dc76.mp4' },
        { type: 'video', src: 'https://cdn.shopify.com/videos/c/o/v/fa315de745c44dc0aa32b37a7492d589.mp4' }

    ];


    const randomMedia = media[Math.floor(Math.random() * media.length)];
    const homeSection = document.querySelector('.home-section');

    if (!homeSection) {
        console.error('Element with class "home-section" not found.');
        return;
    }

    if (randomMedia.type === 'image') {
        // Set image as background
        homeSection.style.backgroundImage = `url(${randomMedia.src})`;
        homeSection.style.backgroundSize = 'cover';
        homeSection.style.backgroundPosition = 'center';
        homeSection.style.backgroundRepeat = 'no-repeat';
    } else if (randomMedia.type === 'video') {
        // Add video element for background
        const videoElement = document.createElement('video');
        videoElement.src = randomMedia.src;
        videoElement.autoplay = true;
        videoElement.loop = true;
        videoElement.muted = true;
        videoElement.style.position = 'absolute';
        videoElement.style.top = 0;
        videoElement.style.left = 0;
        videoElement.style.width = '100%';
        videoElement.style.height = '100%';
        videoElement.style.objectFit = 'cover';
        videoElement.style.zIndex = '-1';

        // Append the video to the home-section
        homeSection.appendChild(videoElement);
        // Set container styles for proper layering
        homeSection.style.position = 'relative';
        homeSection.style.overflow = 'hidden';
    }
});

// MOBILE-------------------------------------------------------------------------------------->>>>>>>>>>>>>>>

document.addEventListener('DOMContentLoaded', function () {
  const media = [
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--1.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--2.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--3.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--4.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--5.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--6.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--7.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--8.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--9.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--10.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--11.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--12.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--13.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--14.jpg?v=1736263167' },
{ type: 'image', src: 'https://cdn.shopify.com/s/files/1/0680/5389/3289/files/mobhom--15.jpg?v=1736263167' },


  ];

  const randomMedia = media[Math.floor(Math.random() * media.length)];
  const mobiHomeSection = document.querySelector('.mobi-home-section');

  if (!mobiHomeSection) {
    console.error('Element with class "mobi-home-section" not found.');
    return;
  }

  if (randomMedia.type === 'image') {
    // Set image as background for mobile
    mobiHomeSection.style.backgroundImage = `url(${randomMedia.src})`;
    mobiHomeSection.style.backgroundSize = 'cover';
    mobiHomeSection.style.backgroundPosition = 'center';
    mobiHomeSection.style.backgroundRepeat = 'no-repeat';
  } else if (randomMedia.type === 'video') {
    // Add video element for background on mobile
    const videoElement = document.createElement('video');
    videoElement.src = randomMedia.src;
    videoElement.autoplay = true;
    videoElement.loop = true;
    videoElement.muted = true;
    videoElement.style.position = 'absolute';
    videoElement.style.top = 0;
    videoElement.style.left = 0;
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoElement.style.objectFit = 'cover';
    videoElement.style.zIndex = '-1';

    // Append the video to the mobi-home-section
    mobiHomeSection.appendChild(videoElement);
    mobiHomeSection.style.position = 'relative';
    mobiHomeSection.style.overflow = 'hidden';
  }
});
